import React from 'react';

/**
 * Horizontal-scroll tab strip for the Log Food hub.
 * One tab is always selected. Tabs that depend on FatSecret hide themselves
 * automatically when their endpoint returns 503 (parent passes `visibleTabs`).
 */
const TAB_CONFIG = [
  { key: 'foods', label: 'Foods' },
  { key: 'restaurants', label: 'Restaurants' },
  { key: 'meals', label: 'Meals' },
  { key: 'barcode', label: 'Barcode' },
  { key: 'manual', label: 'Manual' },
];

export default function TabStrip({ activeTab, onChange, visibleTabs }) {
  const tabs = TAB_CONFIG.filter(function (t) {
    return !visibleTabs || visibleTabs.includes(t.key);
  });
  return (
    <div
      className="border-b border-border bg-background"
      data-testid="log-food-tab-strip"
    >
      <div className="flex overflow-x-auto no-scrollbar gap-1 px-2">
        {tabs.map(function (tab) {
          const active = tab.key === activeTab;
          return (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={active}
              data-testid={'log-food-tab-' + tab.key}
              onClick={function () { onChange(tab.key); }}
              className={
                'whitespace-nowrap px-4 py-3 text-sm font-medium transition-colors relative ' +
                (active
                  ? 'text-foreground'
                  : 'text-muted-foreground hover:text-foreground')
              }
            >
              {tab.label}
              {active && (
                <span
                  aria-hidden="true"
                  className="absolute bottom-0 left-2 right-2 h-0.5 bg-primary rounded-full"
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
